import PropTypes from "prop-types"


const properties = {
  audience: PropTypes.string.isRequired,
  backstageUserId: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  failedAttemptCount: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  issuer: PropTypes.string.isRequired,
  lastUsedAt: PropTypes.string,
  lastUsedIp: PropTypes.string,
  name: PropTypes.string.isRequired,
  organizationId: PropTypes.string.isRequired,
  publicKey: PropTypes.string.isRequired,
  revokedAt: PropTypes.string,
  status: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string,
  usageCount: PropTypes.number.isRequired
}

const RevokeOrganizationPublicKeyOutputShapeShape = PropTypes.exact(properties)

export default RevokeOrganizationPublicKeyOutputShapeShape
export { properties }
